import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from './BaseOptionChart';

// ----------------------------------------------------------------------

var pt = require("apexcharts/dist/locales/pt.json");


const CHART_DATA = [
  {
    name: 'N.º de Acessos',
    type: 'area',
    data: [30, 50, 30, 27, 13, 22, 20, 31, 44, 22, 30]
  },
  {
    name: 'N.º de Sessões',
    type: 'area',
    data: [44, 65, 41, 67, 22, 43, 21, 41, 56, 27, 43]
  },
];

export default function AtividadeNoSistema() {
  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      locales: [pt],
      defaultLocale: 'pt',
    },

    stroke: { 
      width: [2, 3],
      curve: 'smooth'
    },
    plotOptions: { 
      bar: { columnWidth: '11%', borderRadius: 4 } 
    },
    fill: { 
      type: ['gradient', 'gradient'] 
    },
    
    labels: [
      '01/01/2021',
      '02/01/2021',
      '03/01/2021',
      '04/01/2021',
      '05/01/2021',
      '06/01/2021',
      '07/01/2021',
      '08/01/2021',
      '09/01/2021',
      '10/01/2021',
      '11/01/2021'
    ],
    xaxis: { 
      type: 'datetime' 
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} `; // write something
          }
          return y;
        }
      }
    }
  });

  return (
    <Card>
      <CardHeader title="Atividade no Sistema" />{/*subheader="(+43%) que no ano passado" />*/}
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="line" series={CHART_DATA} options={chartOptions} height={250} />
      </Box>
    </Card>
  );
}
